import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";

const AboutBanner: React.FC = () => {
  const { t, dir } = useLanguage();
  const isRtl = dir === "rtl";

  const content = (t as any)?.aboutHero || {};
  const title = content.title || "Where education dreams come true.";
  const subtitle =
    content.subtitle ||
    "10+ years helping Arab students build their future in Egypt.\nWe've guided thousands of students through the full journey and we're still at it.";
  const image = content.image || "/images/about-hero-classroom.png";

  const sideGradient = isRtl
    ? "linear-gradient(270deg, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.54) 42%, rgba(0,0,0,0.12) 100%)"
    : "linear-gradient(90deg, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.54) 42%, rgba(0,0,0,0.12) 100%)";

  return (
    <section
      className="relative overflow-hidden text-white"
      aria-labelledby="about-hero-title"
    >
      <div className="relative min-h-screen">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url('${image}')` }}
          aria-hidden="true"
        />

        <div className="absolute inset-0 bg-second-color/20 mix-blend-multiply" />
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute inset-0" style={{ background: sideGradient }} />

        <div
          className={`site-container relative z-10 flex min-h-screen items-end pb-10 pt-28 sm:pb-14 sm:pt-32 lg:pb-16 ${
            isRtl ? "justify-end text-right" : "justify-start text-left"
          }`}
        >
          <div
            className={`flex w-full max-w-[759px] flex-col gap-3 ${
              isRtl ? "items-end" : "items-start"
            }`}
          >
            <h1
              id="about-hero-title"
              className="hero-title w-full max-w-[759px] text-balance text-white"
            >
              {title}
            </h1>
            <p className="hero-subtitle w-full max-w-[609px] whitespace-pre-line text-white/90">
              {subtitle}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutBanner;
